import {BASE_URL} from "../../utils/config";

export const getRegisteredUsers = async (axiosInstance, filters) => {
    try {
        const response = await axiosInstance.post(`${BASE_URL}/admin/user/get-registered-users`, filters);
        return response.data;
    } catch (error) {
        console.log("(admin/userApi.js) Error while fetching registered users: ", error);
    }
}

export const getLoggedInUsers = async (axiosInstance, filters) => {
    try {
        const response = await axiosInstance.post(`${BASE_URL}/admin/user/get-logged-in-users`, filters);
        return response.data;
    } catch (error) {
        console.log("(admin/userApi.js) Error while fetching logged-in users: ", error);
    }
}
